import $ from 'jquery';
import { initApp } from './utils/dom.js';
import { loadTreeData } from './utils/api.js';
import { generateTabs, initTabs } from './components/Tabs.js';
import { generateOrderForm, initOrderForm } from './components/OrderForm.js';
import { generateFreeCheatForm, initFreeCheatForm, getFreeCheatData } from './components/FreeCheatForm.js';
import { initModal } from './components/Modal.js';

window.application = window.application || {};

$(async function () {
	Object.assign(application, await loadTreeData());

	$('[data-select-list]').empty();
	$('[data-select-services]').empty();
	$('.calc__block--second').empty();
	function getSocialEntry(obj, keyLower) {
		return Object.entries(obj || {}).find(([name]) => name.toLowerCase() === keyLower.toLowerCase());
	}

	const key = decodeURIComponent(window.location.pathname).split('/').filter(Boolean)[0] || '';
	const socialEntry = getSocialEntry(application.data, key);
	const social = socialEntry?.[0] || key;
	const services = socialEntry?.[1] || {};
	generateTabs(social, services, true);
	generateOrderForm(social, services, true);

	$('.calc__block--first [data-option-inner-button]:first').click();
	$('.tabs__content--active [data-option-inner-button]:first').click();

	await generateFreeCheatForm(getFreeCheatData);
	initTabs();
	initOrderForm();
	initFreeCheatForm();
	initModal();
	initApp();
});
